import randomWords from 'random-words';
import { createMultipleMenuItems } from './menu-item.js';

const randomId = (length) =>
  Math.floor(
    Math.pow(10, length - 1) +
      Math.random() * (Math.pow(10, length) - Math.pow(10, length - 1) - 1),
  );

export const createMenuCollection = ({
  numberProducts = 'random',
  groupFooter = randomWords({ exactly: 4, join: ' ' }),
  groupHeader = randomWords({ exactly: 4, join: ' ' }),
  groupId = randomId(5),
  groupImage = '',
  groupName = randomWords({ exactly: 2, join: ' ' }),
  items = createMultipleMenuItems(numberProducts),
} = {}) => {
  try {
    const payload = {
      groupFooter,
      groupHeader,
      groupId,
      groupImage,
      groupName,
      items,
    };
    return payload;
  } catch (error) {
    console.error('unable to generate multiple menu items', error);
    return {};
  }
};

export const createMultipleMenuCollections = ({
  numberCollections = 2,
  numberProducts = 'random',
}) => {
  try {
    return [...Array(numberCollections)].map((i) =>
      createMenuCollection(numberProducts),
    );
  } catch (error) {
    console.error('unable to generate multiple menu collections', error);
    return [];
  }
};
